import React, { useCallback } from 'react';

import { PrivacyPolicy as StyledPrivacyPolicy } from './PrivacyPolicy.styles';

import Loading from "../../components/Loading";
import { formatPhone } from '../../utils/formatter.js';
import { useWindowDimensions } from '../../utils/windowDimensionSize';
import Header from '../../components/Header';
import Container from '../../components/Container';

function PrivacyPolicy({
	form,
	loading,
	cpf,
	onSubmit,
	setAcceptedTerms,
	acceptedTerms,
	onChangeCpfText
}) {
	const { width } = useWindowDimensions();

	const isMobile = width < 600;

	const renderFooter = useCallback(() => {
		return (
			<StyledPrivacyPolicy.Footer>
				<StyledPrivacyPolicy.Footer.Terms>
					<StyledPrivacyPolicy.Footer.Terms.Link href="https://drive.google.com/file/d/11f07WOLbgle_cbea8rGH7mq3d_ur982I/view?usp=drive_link" target="_blank" style={{ marginRight: '16px' }}>
						Termos de uso
					</StyledPrivacyPolicy.Footer.Terms.Link>

					<StyledPrivacyPolicy.Footer.Terms.Link href="https://drive.google.com/file/d/1O8hDS3SGx_jDPjL_eRZoiBxbJl_l0gB4/view?usp=drive_link" target="_blank">
						Política de Privacidade
					</StyledPrivacyPolicy.Footer.Terms.Link>
				</StyledPrivacyPolicy.Footer.Terms>

				<div className="doca-toggle__container doca-mt-4">
					<div className="doca-toggle__input-container">
						<input
							className="doca-toggle"
							id="accepted-term"
							type="checkbox"
							checked={acceptedTerms} onChange={() => setAcceptedTerms(value => !value)}
						/>

						<label
							className="doca-toggle__switch"
							htmlFor="accepted-term"
						/>
					</div>

					<label className="doca-form__label doca-form__label--inline" htmlFor="accepted-term">
						Declaro que li e estou de acordo com os termos
					</label>
				</div>

				<button className="doca-button doca-button--primary doca-button--block doca-button--large doca-mt-4" disabled={!acceptedTerms} type="primary" onClick={onSubmit}>
					Preencher questionário
				</button>
			</StyledPrivacyPolicy.Footer>
		)
	}, [acceptedTerms, onSubmit, setAcceptedTerms]);

	if (loading || !form) {
		return (
			<div className="ds-flex ds-flex__item ds-flex__align--center h-100">
				<Loading />
			</div>
		);
	}

	return (
		<Container>
			<Header />

			<StyledPrivacyPolicy className="doca bg--light-low">
				<StyledPrivacyPolicy.Container>
					<StyledPrivacyPolicy.FlexContainer>
						<StyledPrivacyPolicy.Title>
							Olá, {form?.patient?.name}
						</StyledPrivacyPolicy.Title>

						<StyledPrivacyPolicy.Subtitle className="doca-mt-2">
							Você recebeu um questionário para preencher e assinar
						</StyledPrivacyPolicy.Subtitle>

						<StyledPrivacyPolicy.Card className="doca-mt-6">
							<StyledPrivacyPolicy.Card.Title className="doca-mt-mb-3">Remetente</StyledPrivacyPolicy.Card.Title>

							<StyledPrivacyPolicy.Card.Company>
								<StyledPrivacyPolicy.Card.Company.Info>
									<StyledPrivacyPolicy.Card.Company.Info.Name>{form?.company?.name}</StyledPrivacyPolicy.Card.Company.Info.Name>

									<StyledPrivacyPolicy.Card.Company.ContactInfo className="doca-mt-2">
										{form?.company?.contact_email && (<StyledPrivacyPolicy.Card.Company.Info.Contact>{form?.company?.contact_email}</StyledPrivacyPolicy.Card.Company.Info.Contact>)}

										<StyledPrivacyPolicy.Card.Company.Info.Contact>{formatPhone(form?.company?.contact_phone) || '-'}</StyledPrivacyPolicy.Card.Company.Info.Contact>
									</StyledPrivacyPolicy.Card.Company.ContactInfo>
								</StyledPrivacyPolicy.Card.Company.Info>
							</StyledPrivacyPolicy.Card.Company>
						</StyledPrivacyPolicy.Card>

						<div className="doca-mt-4 doca-mb-2">
							<p className="doca-text--medium doca-text--extra-small">Dúvidas sobre o Documento?</p>
							<p className="doca-text--extra-small doca-mt-1">Se você tem dúvidas ou precisar modificar o documento, entre em contato com o remetente.</p>
						</div>
					</StyledPrivacyPolicy.FlexContainer>

					{isMobile ? (
						<StyledPrivacyPolicy.FooterContainer>
							{renderFooter()}
						</StyledPrivacyPolicy.FooterContainer>
					) : renderFooter()}
				</StyledPrivacyPolicy.Container>

			</StyledPrivacyPolicy>
		</Container>
	);
}

export default PrivacyPolicy;
